import React from "react";

const PercentChangeBox = ({ value }) => {
  const isPositive = value > 0;
  const isNegative = value < 0;

  const baseStyle =
    "px-3 py-2 rounded-sm text-sm text-center min-w-[110px] transition-all duration-200";

  const colorStyle = isPositive
    ? "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-400"
    : isNegative
    ? "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400"
    : "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400";

  return (
    <div className={`${baseStyle} ${colorStyle}`}>
      <div className="flex items-center justify-center gap-1">
        {isPositive && <span>▲</span>}
        {isNegative && <span>▼</span>}
        <span>
          {isPositive && "+"}
          {value}%
        </span>
      </div>
    </div>
  );
};

export default PercentChangeBox;
